import script from "./ModalConfirmacionPlazasLibres.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirmacionPlazasLibres.vue?vue&type=script&setup=true&lang=js"

import "./ModalConfirmacionPlazasLibres.vue?vue&type=style&index=0&id=673a9a27&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673a9a27"]])

export default __exports__